export const isString = (input: unknown): input is string => {
    return typeof input === 'string';
};

export const isArray = (input: unknown): input is any[] => {
    return Array.isArray(input);
};

export const isNumber = (input: unknown): input is number => {
    return typeof input === 'number';
};

export const isNumberOrStringNumber = (input: unknown): input is number => {
    if (input === null) return false;
    if (typeof input === 'string' && input.trim() === '') {
        return false;
    }
    return !isNaN(Number(input));
};

export function includes<T extends U, U>(array: ReadonlyArray<T>, el: U): el is T {
    return array.includes(el as T);
}

export const isObject = (input: unknown): input is Record<string, unknown> => {
    return typeof input === 'object' && input !== null && !Array.isArray(input);
};
